import { ALL } from '@/config/constants';
import { lomavisCreatorRootState } from '@/pages/lomavisCreator';
import { setModalUiContent } from '@/redux/slices/lomavisCreator/lomavisCreator';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

interface Props {
  platform: string;
}

const AltTagButton: React.FC<Props> = ({ platform }) => {
  const dispatch = useDispatch();

  const useSeparateMediaFiles = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.useSeparateMediaFiles
  );

  console.log('separate media files', useSeparateMediaFiles);
  return (
    <div
      className="btn btn-sm btn-bg-white border border-dark px-3"
      style={{
        zIndex: 3
      }}
      onClick={() => {
        dispatch(
          setModalUiContent({
            modal: 'mediaAltTags',
            attribute: 'platform',
            value: useSeparateMediaFiles ? platform : ALL
          })
        );
        dispatch(
          setModalUiContent({
            modal: 'mediaAltTags',
            attribute: 'toggle',
            value: true
          })
        );
      }}
    >
      <i style={{ padding: '0px' }} className="fa-solid fa-tag text-dark"></i>
    </div>
  );
};

export default AltTagButton;
